import { HttpErrorResponse } from "@angular/common/http";

export function getErrorMessage(err: unknown): string {
  if (err instanceof HttpErrorResponse) {
    return (err as HttpErrorResponse).error.detail;
  }
  return err instanceof Error ? err.message : '';
}

export * from './date-range';
export * from './chart-canvas';
export * from './type-set';